import ProductDetailHeader from "@components/store/product-detail/shared/product-detail-header";
import PropertiesAccordionList from "@components/store/product-detail/shared/properties-accordion-list";
import ProductInfoSection from "@components/store/product-detail/shared/product-info-section";
import ProductDescriptionAccordion from "@components/store/product-detail/shared/accordion/product-description";

import { useProductInfoContext } from "@contexts/product-info-context";
import useStoreCurrencyConverter from "@hooks/currency/use-store-currency-converter";

import styles from "./main.module.scss";

const ByoDetails = ({ product }) => {
  const { formatPriceInDisplayStoreCurrency } = useStoreCurrencyConverter();
  const { hidePriceDetail = false } = useProductInfoContext();
  return (
    <div className={`${styles.snackContainerFluid} byoContainerFluid`}>
      <ProductDetailHeader
        minPoints={!hidePriceDetail && formatPriceInDisplayStoreCurrency(product.priceIn)}
        showProductName
        product={product}
      />
      <ProductDescriptionAccordion product={product} />
      <PropertiesAccordionList instructions={product?.productDetail?.orderInstructions} />
      <ProductInfoSection product={product} />
    </div>
  );
};
export default ByoDetails;
